@if (bookingActionType() === bookingActionEnum.VARDEN_BOOKING &&
!isAreYouListedModalEnabled() &&
!isJustLink()) {
  <app-ui-button
    [color]="hasTimeslots() ? 'outline-tertiary' : 'green'"
    [eventAction]="gaEventAction()"
    [eventCategory]="gaEventCategory()"
    [eventLabel]="gaEventLabel()"
    [eventParams]="customGa4Params()"
    [ngClass]="btnCssClass()"
    (click)="navigateToBookingUrl()"
    [size]="size()"
    appGtmEvent
    appGtmGa4Event
    expanded="block"
    rel="nofollow"
    tabindex="null"
  >
    @if (hasTimeslots()) {
      <app-ui-icon name="calendar" size="sm"></app-ui-icon>
    }
    {{ btnLabel() }}
  </app-ui-button>
}

@if (bookingActionType() === bookingActionEnum.URL && !isAreYouListedModalEnabled()) {
  <app-ui-button
    (click)="handleBtnClick(bookingUrl(), btnTarget())"
    [color]="btnColor()"
    [eventAction]="'extern bokning'"
    [eventCategory]="'bokning'"
    [eventLabel]="eventtext()"
    [eventParams]="customGa4Params()"
    [ngClass]="btnCssClass()"
    [size]="size()"
    appGtmEvent
    appGtmGa4Event
    expanded="block"
    rel="nofollow"
  >
    <app-ui-icon name="external" size="sm"></app-ui-icon>
    {{ btnLabel() }}
  </app-ui-button>
}

@if (bookingActionType() === bookingActionEnum.POPUP && !isAreYouListedModalEnabled()) {
  <app-ui-button
    (click)="openPopup()"
    [color]="'green'"
    [ngClass]="btnCssClass()"
    [size]="size()"
    expanded="block"
  >
    {{ btnLabel() }}
  </app-ui-button>
}

@if (bookingActionType() === bookingActionEnum.CUSTOM_POPUP && !isAreYouListedModalEnabled()) {
  <app-ui-button
    (click)="openCustomPopup()"
    [color]="'green'"
    [ngClass]="btnCssClass()"
    [size]="size()"
    expanded="block"
  >
    {{ btnLabel() }}
  </app-ui-button>
}

@if (isJustLink() && bookingActionType() === bookingActionEnum.VARDEN_BOOKING) {
  <div
    [eventAction]="gaEventAction()"
    [eventCategory]="gaEventCategory()"
    [eventLabel]="gaEventLabel()"
    [eventParams]="customGa4Params()"
    [ngClass]="btnCssClass()"
    (click)="navigateToBookingUrl()"
    appGtmEvent
    appGtmGa4Event
    rel="nofollow"
    class="cursor-pointer"
  >{{ btnLabel() }}
  </div>
}

